
import {   ADD_NEW_FORM_ERROR, ADD_NEW_FORM_POST_ERROR,ADD_NEW_FORM_SUCCESS, GET_ALL_REPORT_SUCCESS,
    GET_CONC_FORM_ERROR, GET_CONC_FORM_POST_ERROR, GET_CONC_FORM_SUCCESS} from "../actions/types";

export default (state = {  
    error: null,
    status:[],
    addForm:{},
    getForm:[],
    success:false,
}, action) => {
    switch (action.type) {
        case ADD_NEW_FORM_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: action.payload.message,
            };
            break;
        case GET_ALL_REPORT_SUCCESS:
            return {
                ...state,
                error: state.error,
                loading:false,
                status: action.payload,
                success:true,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Retrieved Successfully',
            };
            break;
            case ADD_NEW_FORM_SUCCESS:
                return {
                    ...state,
                    error: state.error,
                    loading:false,
                    status: [],
                    success:true,
                    addForm:action.payload,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: 'New Company Added Successfully',
                };
                break;
            
        case ADD_NEW_FORM_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Retrieve Error | ' + state.error,
            };
            break;
            case GET_CONC_FORM_ERROR:
                return {
                    ...state,
                    error: state.error,
                    loading:false,
                    success: false,
                    isSnackbarError: true,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: 'Retrieve Error | It is either you have saved your forms, or it is other error: ' + state.error,
                };
                break;
            
                case GET_CONC_FORM_SUCCESS:
                    return {
                        ...state,
                        error: state.error,
                        loading:false,
                        success: true,
                        getForm:action.payload,
                        isSnackbarError: false,
                        isSwitchSnackbarOn: true,
                        ErrorMessage: 'Retrieve Success ',
                    };
                    break;
                    case GET_CONC_FORM_POST_ERROR:
                        return {
                            ...state,
                            error: state.error,
                            loading:false,
                            success: false,
                            isSnackbarError: true,
                            isSwitchSnackbarOn: true,
                            ErrorMessage: 'Retrieve Error | ' + state.error,
                        };
                        break;
                    
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ConcessionFormReducer.js